import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatbotFunService {

  constructor() { }

  private agentSwitchSubject = new BehaviorSubject<boolean>(false);
  agentSwitch$ = this.agentSwitchSubject.asObservable();
  

  setAgentSwitch(value: boolean) {
    this.agentSwitchSubject.next(value);
  }
  public checkTextLimetation(str) {

    if(str.includes("Can I find more information in the dashboards and")){
      return str.replace(str,"Can I find more information in the dashboards and reports?");

    }else if(str.includes("With what type of services does saned help employ")){
      return str.replace(str,"With what type of services does saned help employees?");

    }else if(str.includes("What data do I need to add to set up my employees")){
      return str.replace(str,"What data do I need to add to set up my employees?")

    }else if(str.includes("What do I do about indirect staff employed throug")){
      return str.replace(str,"What do I do about indirect staff employed through agencies?")

    }else if(str.includes("Do I need to import an organization chart into sa")){
      return str.replace(str,"Do I need to import an organization chart into saned?")
  
    }else if(str.includes("Does saned include Performance Management for emp")){
      return str.replace(str,"Does saned include Performance Management for employees?")

    }else if(str.includes("Does saned work out GOSI in the payroll calculati")){
      return str.replace(str,"Does saned work out GOSI in the payroll calculation?")

    }else if(str.includes("How long does it take to set up my company for sa")){
      return str.replace(str,"How long does it take to set up my company for saned HR?")
    }
    
    else if(str.includes("What are the default options for the policies in")){
      return str.replace(str,"What are the default options for the policies in saned HR?")
    }
  
    else if(str.includes("Do the HR Administrators need to be experienced H")){
      return str.replace(str,"Do the HR Administrators need to be experienced HR professionals?")
    }
    
    else if(str.includes("What are the default options for the policies in")){
      return str.replace(str,"What are the default options for the policies in saned HR?")
    }

    

    else if(str.includes("هل يتم يتم وضع السياسات المتوافقة مع قانون العمل")){
      return str.replace(str,"هل يتم يتم وضع السياسات المتوافقة مع قانون العمل بشكل افتراضي في ساند للموارد البشرية؟")
    }

    else if(str.includes("هل يمكن في ساند حساب مرتبات العملاء الخاضعين لنظا")){
      return str.replace(str,"هل يمكن في ساند حساب مرتبات العملاء الخاضعين لنظام التأمينات الاجتماعية GOSI؟")
    }

    else if(str.includes("كيف تقوم ساند حساب المرتبات للعملاء الخاضعين لنظا")){
      return str.replace(str,"كيف تقوم ساند حساب المرتبات للعملاء الخاضعين لنظام التأمينات الاجتماعية GOSI؟")
    }

    else if(str.includes("كيف يمكن القيام بإجراءات خاصة من أجل دفع الرواتب")){
      return str.replace(str,"كيف يمكن القيام بإجراءات خاصة من أجل دفع الرواتب؟")
    }

    else if(str.includes("هل بوابة و تطبيق ساند موجودين باللغتين العربية وا")){
      return str.replace(str,"هل بوابة و تطبيق ساند موجودين باللغتين العربية والإنجليزية؟")
    }

    else if(str.includes("متى يمكنني البدء باستخدام منصة ساند للموارد البشر")){
      return str.replace(str,"متى يمكنني البدء باستخدام منصة ساند للموارد البشرية في شركتي عند اشتراكي بها؟")
    }

    else if(str.includes("هل أحتاج لتدريب مسبق للتمكن من استخدام منصة ساند")){
      return str.replace(str,"هل أحتاج لتدريب مسبق للتمكن من استخدام منصة ساند للموارد البشرية؟")
    }

    else if(str.includes("هل يجب على المسؤولين في منصة ساند للموارد البشرية")){
      return str.replace(str,"هل يجب على المسؤولين في منصة ساند للموارد البشرية أن يكونوا متخصصين في مجال الموارد البشرية؟")
    }

    else if(str.includes("ما هي البيانات التي أحتاج إضافتها لإعداد الموظفين")){
      return str.replace(str,"ما هي البيانات التي أحتاج إضافتها لإعداد الموظفين لدي؟")
    }

    else if(str.includes("ماذا أفعل من أجل الموظفين غير المباشرين الذين يتم")){
      return str.replace(str,"ماذا أفعل من أجل الموظفين غير المباشرين الذين يتم توظيفهم من خلال الوكالات؟")
    }

    else if(str.includes("هل يمكن لساند مساعدتي في إدارة طلبات ومقابلات الت")){
      return str.replace(str,"هل يمكن لساند مساعدتي في إدارة طلبات ومقابلات التوظيف؟")
    }

    else if(str.includes("هل تقوم ساند أيضاً بالمساعدة في إدارة الأداء للمو")){
      return str.replace(str,"هل تقوم ساند أيضاً بالمساعدة في إدارة الأداء للموظفين؟")
    }

    else if(str.includes("هل يمكنني العثور على مزيد من المعلومات في لوحات ا")){
      return str.replace(str,"هل يمكنني العثور على مزيد من المعلومات في لوحات التقارير؟")
    }

    else if(str.includes("هل يمكنني رؤية لوحات التقارير على من خلال تطبيق ا")){
      return str.replace(str,"هل يمكنني رؤية لوحات التقارير على من خلال تطبيق الهاتف الجوال؟")
    }
    
    else{
      return str;
    }
}

isArabic() : boolean{
  let chatbot_lang = 'ar';
  if (localStorage.getItem('chatbot_lang') !== null) {
    chatbot_lang = localStorage.getItem('chatbot_lang');
  }
  if (chatbot_lang == "ar") {
    return true;
  }else if (chatbot_lang == "en") {
    return false;
  }
}

 isArabicLang(str: string) {
  // Regular expression pattern to match Arabic characters
  var arabicPattern = /[\u0600-\u06FF]/;
  return arabicPattern.test(str.split(" ")[0]);
}

extractNameAndUrl(htmlString) {
  // Create a temporary element to parse the HTML string
  var tempElement = document.createElement('div');
  tempElement.innerHTML = htmlString;

  // Access the <a> tag element
  var aTag = tempElement.querySelector('a');

  // Extract name and URL
  var name = aTag.innerText;
  var url = aTag.getAttribute('href');
  return { name: name, url: url };
}

public checkHelloString(str, chatbot_lang) {
  if (chatbot_lang == "ar") {
    return str.replace(/مرحبا whatsapp:\+[0-9]+/i, "مرحبا");
  } else {
    return str.replace(/hello \+[0-9]+/i, "Hello");
  }
}

public checkGreetForm(str) {
  if (str.includes('Hello! This is the SAMACO V') || str.includes('To provide better assistance,')
    || str.includes('حياك الله وياهلا ! ,,,,,') || str.includes('رقم الجوال المدخل غير صحيح،')
  ) {
    return true;
  } else {
    return false;
  }
}

public checkGreetRanking(str) {
  if (str.includes('Hello! This is the SAMACO V')) {
    return 'Welcome to SAMACO Digital Assistance!';
  } else if (str.includes('حياك الله وياهلا ! ,,,,,')) {
    return 'مرحباً بكم في خدمة المساعدة الرقمية من SAMACO!';
  } else {
    return false;
  }
};

}